import React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import classNames from 'classnames';
import {Button} from '@deviceinsight/ng-ui-basic-components';
type GpioToggleProps = {
	status?: boolean;
	onChange: (status?: boolean) => void;
	canEdit: boolean;
};

const GpioToggleButton = ({status, onChange, canEdit}: GpioToggleProps) => {
	const buttonClass = classNames('gpio_button', {
		low: !status
	});
	return (
		<span className={buttonClass} data-testid="gpio-toggle-button">
			<Button naked onClick={() => onChange(!status)} disabled={!canEdit}>
				{status ? (
					<Trans i18nKey="ruleengine.valueTypes.high">High</Trans>
				) : (
					<Trans i18nKey="ruleengine.valueTypes.low">Low</Trans>
				)}
			</Button>
		</span>
	);
};

export default GpioToggleButton;
